import { render, staticRenderFns } from "./ShareReadOnlyButton.vue?vue&type=template&id=127dca46&scoped=true"
import script from "./ShareReadOnlyButton.vue?vue&type=script&lang=js"
export * from "./ShareReadOnlyButton.vue?vue&type=script&lang=js"
import style0 from "./ShareReadOnlyButton.vue?vue&type=style&index=0&id=127dca46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127dca46",
  null
  
)

export default component.exports